<template>
    <div class="memwrap modulewrap">
        <Cmember :curnavkv="curnavkv" :subtitle="$common.dicword('pwdsetting')">
            <template v-if="isload">
                <div class="account">
                    <div class="mypwd">
                        <dl><dt>{{$common.dicword('pwdold',true)}}</dt><dd><el-input type="password" v-model="pwdold" :class="{iserr:iserrpwdold}" @focus="iserrpwdold=false"></el-input></dd></dl>
                        <dl><dt>{{$common.dicword('pwdnew',true)}}</dt><dd><el-input type="password" v-model="pwdnew" :class="{iserr:iserrpwdnew}" @focus="iserrpwdnew=false"></el-input></dd></dl>
                        <dl><dt>{{$common.dicword('pwdconfirm',true)}}</dt><dd><el-input type="password" v-model="pwdconfirm" :class="{iserr:iserrpwdconfirm}" @focus="iserrpwdconfirm=false"></el-input></dd></dl>
                        <dl><dt>&nbsp;</dt><dd><a href="#" class="btn1" @click="savepwd">{{$common.dicword('setup')}}</a></dd></dl>
                    </div>
                </div>
            </template>
        </Cmember>
    </div>

</template>

<script>
    import { mixinmember } from "@/mixin/mixin"
    export default {
        name: 'password',
        mixins: [mixinmember],
        data() {
            return {
                curnavkv: 8,
                pwdold: '',
                pwdnew: '',
                pwdconfirm: '',

                iserrpwdnew: false,
                iserrpwdold: false,
                iserrpwdconfirm: false,
                isload: true
            };
        },
        methods: {
            savepwd: function () {
                this.iserrpwdnew = this.pwdnew == '';
                this.iserrpwdold = this.pwdold == '';
                this.iserrpwdconfirm = this.pwdconfirm != this.pwdnew;
                let isallow = (!this.iserrpwdnew) && (!this.iserrpwdold) && (!this.iserrpwdconfirm);
                if (isallow) {
                    let jsondata = {
                        'postdata': {
                            'api': 'member', 'act': 'mypwd', "data": { 'pwdnew': this.pwdnew, 'pwdold': this.pwdold }
                        }, 'msg': 'Saveing...'
                    };
                    this.$common.post(jsondata, () => {
                        this.pwdnew = '';
                        this.pwdconfirm = '';
                        this.pwdold = '';
                        this.$common.success('setsuccess');
                    });
                }
            }
        }
    }

</script>
